/**
 * Extract the ISO639 language code from the RFC5646
 * RFC5646 consists of ISO639 with additional language subtags
 * (e.g ISO639: en, RFC5646: en-US)
 */ export var extractIso639LanguageCode = function(lang) {
    return lang === null || lang === void 0 ? void 0 : lang.split('-')[0];
};
export var iso639lang2to3letter = function(language) {
    var langPieces = language.split('-');
    var languageCode = ISO639_1_TO_ISO639_3.get(langPieces[0]) || langPieces[0];
    return langPieces.length > 1 ? "".concat(languageCode, "-").concat(langPieces[1]) : languageCode || language;
};
export var getLabelFromLanguage = function(lang) {
    var langCode = extractIso639LanguageCode(lang);
    var _ISO639_1_TO_ISO639_3_get;
    var iso3Code = (_ISO639_1_TO_ISO639_3_get = ISO639_1_TO_ISO639_3.get(langCode)) !== null && _ISO639_1_TO_ISO639_3_get !== void 0 ? _ISO639_1_TO_ISO639_3_get : langCode;
    var _ISO_639_3_TO_LABEL_get;
    return (_ISO_639_3_TO_LABEL_get = ISO_639_3_TO_LABEL.get(iso3Code)) !== null && _ISO_639_3_TO_LABEL_get !== void 0 ? _ISO_639_3_TO_LABEL_get : null;
};
export var compareIso639LanguageCodes = function(langA, langB) {
    var langCodeA = extractIso639LanguageCode(langA);
    var langCodeB = extractIso639LanguageCode(langB);
    var _ISO639_1_TO_ISO639_3_get, _ISO639_1_TO_ISO639_3_get1;
    return ((_ISO639_1_TO_ISO639_3_get = ISO639_1_TO_ISO639_3.get(langCodeA)) !== null && _ISO639_1_TO_ISO639_3_get !== void 0 ? _ISO639_1_TO_ISO639_3_get : langCodeA) === ((_ISO639_1_TO_ISO639_3_get1 = ISO639_1_TO_ISO639_3.get(langCodeB)) !== null && _ISO639_1_TO_ISO639_3_get1 !== void 0 ? _ISO639_1_TO_ISO639_3_get1 : langCodeB);
};
// This table is a reversed version of the 3-to-2 letter lang table in Shaka's language_utils.js. Note that some languages
// have two possible mappings from 2 to 3 letter, based on two different standards: MARC (obsolete) and ISO639-3. The MARC
// codes are currently commented out below, as they are incompatible with Showmax. If a proposition wishes to use this list
// to retrieve MARC codes, then the table's values will have to be modified to include both MARC and ISO639-3 langs, and
// the caller will choose either the MARC or ISO639-3 lang based on the desired standard.
export var ISO639_1_TO_ISO639_3 = new Map([
    [
        'aa',
        'aar'
    ],
    [
        'ab',
        'abk'
    ],
    [
        'af',
        'afr'
    ],
    [
        'ak',
        'aka'
    ],
    // ['sq', 'alb'],
    [
        'am',
        'amh'
    ],
    [
        'ar',
        'ara'
    ],
    [
        'an',
        'arg'
    ],
    // ['hy', 'arm'],
    [
        'as',
        'asm'
    ],
    [
        'av',
        'ava'
    ],
    [
        'ae',
        'ave'
    ],
    [
        'ay',
        'aym'
    ],
    [
        'az',
        'aze'
    ],
    [
        'ba',
        'bak'
    ],
    [
        'bm',
        'bam'
    ],
    // ['eu', 'baq'],
    [
        'be',
        'bel'
    ],
    [
        'bn',
        'ben'
    ],
    [
        'bh',
        'bih'
    ],
    [
        'bi',
        'bis'
    ],
    [
        'bo',
        'bod'
    ],
    [
        'bs',
        'bos'
    ],
    [
        'br',
        'bre'
    ],
    [
        'bg',
        'bul'
    ],
    // ['my', 'bur'],
    [
        'ca',
        'cat'
    ],
    [
        'cs',
        'ces'
    ],
    [
        'ch',
        'cha'
    ],
    [
        'ce',
        'che'
    ],
    // ['zh', 'chi'],
    [
        'cu',
        'chu'
    ],
    [
        'cv',
        'chv'
    ],
    [
        'kw',
        'cor'
    ],
    [
        'co',
        'cos'
    ],
    [
        'cr',
        'cre'
    ],
    [
        'cy',
        'cym'
    ],
    // ['cs', 'cze'],
    [
        'da',
        'dan'
    ],
    [
        'de',
        'deu'
    ],
    [
        'dv',
        'div'
    ],
    // ['nl', 'dut'],
    [
        'dz',
        'dzo'
    ],
    [
        'el',
        'ell'
    ],
    [
        'en',
        'eng'
    ],
    [
        'eo',
        'epo'
    ],
    [
        'et',
        'est'
    ],
    [
        'eu',
        'eus'
    ],
    [
        'ee',
        'ewe'
    ],
    [
        'fo',
        'fao'
    ],
    [
        'fa',
        'fas'
    ],
    [
        'fj',
        'fij'
    ],
    [
        'fi',
        'fin'
    ],
    [
        'fr',
        'fra'
    ],
    // ['fr', 'fre'],
    [
        'fy',
        'fry'
    ],
    [
        'ff',
        'ful'
    ],
    // ['ka', 'geo'],
    // ['de', 'ger'],
    [
        'gd',
        'gla'
    ],
    [
        'ga',
        'gle'
    ],
    [
        'gl',
        'glg'
    ],
    [
        'gv',
        'glv'
    ],
    // ['el', 'gre'],
    [
        'gn',
        'grn'
    ],
    [
        'gu',
        'guj'
    ],
    [
        'ht',
        'hat'
    ],
    [
        'ha',
        'hau'
    ],
    [
        'he',
        'heb'
    ],
    [
        'hz',
        'her'
    ],
    [
        'hi',
        'hin'
    ],
    [
        'ho',
        'hmo'
    ],
    [
        'hr',
        'hrv'
    ],
    [
        'hu',
        'hun'
    ],
    [
        'hy',
        'hye'
    ],
    [
        'ig',
        'ibo'
    ],
    // ['is', 'ice'],
    [
        'io',
        'ido'
    ],
    [
        'ii',
        'iii'
    ],
    [
        'iu',
        'iku'
    ],
    [
        'ie',
        'ile'
    ],
    [
        'ia',
        'ina'
    ],
    [
        'id',
        'ind'
    ],
    [
        'ik',
        'ipk'
    ],
    [
        'is',
        'isl'
    ],
    [
        'it',
        'ita'
    ],
    [
        'jv',
        'jav'
    ],
    [
        'ja',
        'jpn'
    ],
    [
        'kl',
        'kal'
    ],
    [
        'kn',
        'kan'
    ],
    [
        'ks',
        'kas'
    ],
    [
        'ka',
        'kat'
    ],
    [
        'kr',
        'kau'
    ],
    [
        'kk',
        'kaz'
    ],
    [
        'km',
        'khm'
    ],
    [
        'ki',
        'kik'
    ],
    [
        'rw',
        'kin'
    ],
    [
        'ky',
        'kir'
    ],
    [
        'kv',
        'kom'
    ],
    [
        'kg',
        'kon'
    ],
    [
        'ko',
        'kor'
    ],
    [
        'kj',
        'kua'
    ],
    [
        'ku',
        'kur'
    ],
    [
        'lo',
        'lao'
    ],
    [
        'la',
        'lat'
    ],
    [
        'lv',
        'lav'
    ],
    [
        'li',
        'lim'
    ],
    [
        'ln',
        'lin'
    ],
    [
        'lt',
        'lit'
    ],
    [
        'lb',
        'ltz'
    ],
    [
        'lu',
        'lub'
    ],
    [
        'lg',
        'lug'
    ],
    // ['mk', 'mac'],
    [
        'mh',
        'mah'
    ],
    [
        'ml',
        'mal'
    ],
    // ['mi', 'mao'],
    [
        'mr',
        'mar'
    ],
    // ['ms', 'may'],
    [
        'mk',
        'mkd'
    ],
    [
        'mg',
        'mlg'
    ],
    [
        'mt',
        'mlt'
    ],
    [
        'mn',
        'mon'
    ],
    [
        'mi',
        'mri'
    ],
    [
        'ms',
        'msa'
    ],
    [
        'my',
        'mya'
    ],
    [
        'na',
        'nau'
    ],
    [
        'nv',
        'nav'
    ],
    [
        'nr',
        'nbl'
    ],
    [
        'nd',
        'nde'
    ],
    [
        'ng',
        'ndo'
    ],
    [
        'ne',
        'nep'
    ],
    [
        'nl',
        'nld'
    ],
    [
        'nn',
        'nno'
    ],
    [
        'nb',
        'nob'
    ],
    [
        'no',
        'nor'
    ],
    [
        'ny',
        'nya'
    ],
    [
        'oc',
        'oci'
    ],
    [
        'oj',
        'oji'
    ],
    [
        'or',
        'ori'
    ],
    [
        'om',
        'orm'
    ],
    [
        'os',
        'oss'
    ],
    [
        'pa',
        'pan'
    ],
    // ['fa', 'per'],
    [
        'pi',
        'pli'
    ],
    [
        'pl',
        'pol'
    ],
    [
        'pt',
        'por'
    ],
    [
        'ps',
        'pus'
    ],
    [
        'qu',
        'que'
    ],
    [
        'rm',
        'roh'
    ],
    [
        'ro',
        'ron'
    ],
    // ['ro', 'rum'],
    [
        'rn',
        'run'
    ],
    [
        'ru',
        'rus'
    ],
    [
        'sg',
        'sag'
    ],
    [
        'sa',
        'san'
    ],
    [
        'si',
        'sin'
    ],
    [
        'sk',
        'slk'
    ],
    // ['sk', 'slo'],
    [
        'sl',
        'slv'
    ],
    [
        'se',
        'sme'
    ],
    [
        'sm',
        'smo'
    ],
    [
        'sn',
        'sna'
    ],
    [
        'sd',
        'snd'
    ],
    [
        'so',
        'som'
    ],
    [
        'st',
        'sot'
    ],
    [
        'es',
        'spa'
    ],
    [
        'sq',
        'sqi'
    ],
    [
        'sc',
        'srd'
    ],
    [
        'sr',
        'srp'
    ],
    [
        'ss',
        'ssw'
    ],
    [
        'su',
        'sun'
    ],
    [
        'sw',
        'swa'
    ],
    [
        'sv',
        'swe'
    ],
    [
        'ty',
        'tah'
    ],
    [
        'ta',
        'tam'
    ],
    [
        'tt',
        'tat'
    ],
    [
        'te',
        'tel'
    ],
    [
        'tg',
        'tgk'
    ],
    [
        'tl',
        'tgl'
    ],
    [
        'th',
        'tha'
    ],
    // ['bo', 'tib'],
    [
        'ti',
        'tir'
    ],
    [
        'to',
        'ton'
    ],
    [
        'tn',
        'tsn'
    ],
    [
        'ts',
        'tso'
    ],
    [
        'tk',
        'tuk'
    ],
    [
        'tr',
        'tur'
    ],
    [
        'tw',
        'twi'
    ],
    [
        'ug',
        'uig'
    ],
    [
        'uk',
        'ukr'
    ],
    [
        'ur',
        'urd'
    ],
    [
        'uz',
        'uzb'
    ],
    [
        've',
        'ven'
    ],
    [
        'vi',
        'vie'
    ],
    [
        'vo',
        'vol'
    ],
    // ['cy', 'wel'],
    [
        'wa',
        'wln'
    ],
    [
        'wo',
        'wol'
    ],
    [
        'xh',
        'xho'
    ],
    [
        'yi',
        'yid'
    ],
    [
        'yo',
        'yor'
    ],
    [
        'za',
        'zha'
    ],
    [
        'zh',
        'zho'
    ],
    [
        'zu',
        'zul'
    ]
]);
var ISO_639_3_TO_LABEL = new Map([
    [
        'eng',
        'English'
    ],
    [
        'spa',
        'Spanish'
    ]
]);

//# sourceMappingURL=iso639-language-helper.js.map